/** @module Merchandising/MerchOptionSubtype */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/AddPath",
	"csi/def/Relationship",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,AddPath,Relationship,Ref,xml,Query) {

	return declare(Ref, {

		/**
		 * Creating the store for option subtypes
		 * @param {Context} ctx
		 * @param {Heading} h
		 */
		getStoreRelationship: function(ctx, h) {
			// summary: need special code here because MerchOption is owned by MerchProduct, but created under MerchProductVersion
			return lang.mixin(new Relationship(), {
				m_query: new Query().Attr("Active", xml.OP_EQUALS, true, "Child:Settings"),
				m_typeNode: "MerchOptionSubtype",
				m_url: ctx.getParentURL(),
				m_addPaths: [lang.mixin(new AddPath(), {
					m_path: "Child:Subtype/Child:Settings/Child:ChildrenSubtypes"
				})]
			});
		}
	});
});